import React, { useCallback, useContext, useEffect, useState } from "react";
import { TostMsg } from "../../../../../App";
import TodaysWFH from "./TodayWhf";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
const defaultImage = "/images/placeholder_profile.png";

const WfhManagerReport = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const history = useHistory();

  useEffect(() => {
    GetMasterSystemAlertList("WFH_ContactManager", 1);
  }, []);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const navigateToProfilePage = () => {
    history.push(`Profile/${userDetails?.OverseerGuid}`);
  };

  return (
    <div className="row sidecarddd">
      <div className="col-xl-12">
        <div className="">
          <div className="card-body contact-mandiv">
            <a className="reporting-manager">
              <h6>{masterSystemAlertData}</h6>
              {/* <Link to={`Profile/${userDetails?.OverseerGuid}`}> */}
              <a>
                <img
                  src={userDetails?.OverseerImage || defaultImage}
                  onError={handleImageError}
                  onClick={navigateToProfilePage}
                  className="c-pointer"
                />
                <strong  onClick={navigateToProfilePage} >{userDetails?.OverseerName}</strong>
              </a>
              {/* </Link> */}
            </a>
          </div>
        </div>
      </div>
      <TodaysWFH />
    </div>
  );
};

export default WfhManagerReport;
